import { useState } from "react";
import "./promo.css";
import OnyxOsSignature from "./OnyxOsSignature";

export function Brand({ footer = false }: { footer?: boolean }) {
  if (!footer) {
    return (
      <a className="brand onyx-brand header-brand" href="/" aria-label="ONYXWEB | OPTIMATEO – domů">
        <b className="onyx-wordmark">ONYX<span>WEB</span></b>
        <span className="onyx-brand-divider" aria-hidden="true"> | </span>
        <strong className="onyx-partner-wordmark">OPTIMATEO</strong>
      </a>
    );
  }

  return (
    <a className={"brand onyx-brand" + (footer ? " footer-brand" : "")} href="/" aria-label="ONYXWEB – domů">
      <b className="onyx-wordmark">ONYX<span>WEB</span></b>
      <span className="onyx-brand-signature">| by OPTIMATEO</span>
      {footer && <small>Powered by <OnyxOsSignature /></small>}
    </a>
  );
}


export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
      <header className="topbar">
        <div className="onyx-utility">
          <div className="shell onyx-utility-inner">
            <span><span className="onyx-utility-brand">ONYXWEB</span> | <span className="onyx-utility-partner">OPTIMATEO</span> · WEBDESIGN / DIGITÁLNÍ ŘEŠENÍ</span>
            <a href="/#audit">Nezávazná poptávka ↗</a>
          </div>
        </div>
        <div className="shell topbar-inner">
          <Brand />
          <nav aria-label="Hlavní navigace">
            <a href="/#styles">Šablony</a>
            <a href="/vizitka">Vizitka+</a>
            <a href="/builder">ONYXWEBbuilder+</a>
            <a href="/#services">Řešení</a>
            <a href="/gastro">ONYXGASTRO+</a>
            <a href="/#references">Realizace</a>
            <a href="https://www.optihub.cz" target="_blank" rel="noopener noreferrer">OptiHub ↗</a>
            <a href="/#about">O nás</a>
            <a href="/#audit">Kontakt</a>
          </nav>
          <div className="header-cta-group" aria-label="Rychlé akce ONYXWEB">
            <a className="primary header-cta" href="/#audit">Nezávazně poptat web <span>→</span></a>
            <a className="secondary header-cta-secondary" href="https://www.optimateo.com/audit-zdarma">Chci audit <span>↗</span></a>
          </div>
          <button
            className="onyx-menu-toggle"
            type="button"
            aria-controls="onyx-mobile-navigation"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >{menuOpen ? "Zavřít ✕" : "Menu ☰"}</button>
        </div>
        {menuOpen && (
          <nav className="onyx-mobile-nav" id="onyx-mobile-navigation" aria-label="Mobilní navigace">
            <a href="/#styles" onClick={() => setMenuOpen(false)}>Šablony</a>
            <a href="/builder">ONYXWEBbuilder+</a>
            <a href="/#services" onClick={() => setMenuOpen(false)}>Řešení</a>
            <a href="/gastro">ONYXGASTRO+</a>
            <a href="/#references" onClick={() => setMenuOpen(false)}>Realizace</a>
            <a href="https://www.optihub.cz" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>OptiHub ↗</a>
            <a href="/#about" onClick={() => setMenuOpen(false)}>O nás</a>
            <a href="/#audit" onClick={() => setMenuOpen(false)}>Kontakt</a>
            <a className="onyx-mobile-primary" href="/#audit" onClick={() => setMenuOpen(false)}>Nezávazně poptat web →</a>
            <a className="onyx-mobile-secondary" href="https://www.optimateo.com/audit-zdarma" onClick={() => setMenuOpen(false)}>Chci audit ↗</a>
          </nav>
        )}
      </header>

  );
}

export function SiteFooter() {
  return (
      <footer id="about">
        <div className="shell footer-inner">
          <Brand footer />
          <span>Strategie · Design · Vývoj · Automatizace · Podpora · <a href="https://www.optihub.cz" target="_blank" rel="noopener noreferrer">OptiHub ↗</a><br/>Provozovatel: Petr Matěj · IČO 02558220 · OPTIMATEO</span>
        </div>
      </footer>
  );
}
